module.exports = __webpack_public_path__ + "img/extension.80c06f97.svg";